<template>
  <section>
    <loader ref="loader" />
    <Form @submit="signInContinue">
      <div class="cs-sign-in__inputs-box">
        <text-input
          name="email"
          id="email"
          v-model:value="email"
          :placeholder="$t('sign-in.email')"
          ref="email"
          :schema="emailSchema"
          autocomplete="email"
        />
      </div>
      <small class="cs-sign-in__error" v-if="errors?.email">
        {{ errors.email }}
      </small>

      <CustomButton
        className="cs-sign-in__btn w-100 button-default mt-4 p-12"
        type="submit"
        :name="continuebtn"
      />
    </Form>
    <div class="sign-up-text mt-4">
      or
      <span @click="doSigin()" class="sign-up-btn cursor-pointer">
        {{ $t("magic-link.loginWithPass") }}
      </span>
    </div>
    <div class="sign-up-text">
      {{ changePartnerLabelName(marketInfo, "sign-in.no-account") }}
      <span @click="doSignUp()" class="sign-up-btn cursor-pointer">
        {{ $t("sign-in.sign-up") }}
      </span>
    </div>
  </section>
</template>

<script>
import { Magic } from "magic-sdk";
import { mapGetters } from "vuex";
import { GET_USER_INFO, USER_TRACK_EVENTS } from "@/store/modules/user/consts";
import CustomButton from "../views/customButton.vue";
import * as Yup from "yup";
export default {
  data() {
    return {
      popup: null,
      continuebtn: "Continue with email",
      email: this.$store.getters["auth/userEmail"] || "",
      oneTimePass: null,
      m: new Magic(process.env.VUE_APP_MAGIC_PUBLISHABLE_KEY),
    };
  },
  props: {
    offMagic: {
      type: Function,
      default: (val) => {},
    },
  },
  computed: {
    ...mapGetters({
      marketInfo: "user/marketInfo",
    }),
  },
  setup() {
    const emailSchema = Yup.string().email().required();
    return { emailSchema };
  },
  components: {
    CustomButton,
  },
  watch: {
    email(newVal) {
      if (newVal) {
        this.error = "";
      }
    },
  },
  methods: {
    doSignUp() {
      this.$router.push({
        name: "SignUp",
      });
    },
    async magicSIGN(token) {
      this.$nextTick(async () => {
        try {
          const encryptedReq = this.encryptStringWithRSA(
            JSON.stringify({
              email: this.email.toLowerCase(),
              // password: 'Test@123',
            })
          );
          await this.$store.dispatch("auth/magicSIGN", {
            encryptedReq,
            token,
          });
          const info = await this.$store.dispatch(`user/${GET_USER_INFO}`);
          if (info.type === 1) {
            if (this.popup) {
              this.popup.focus();
              this.popup.close();
              this.popup = null;
            }
            this.$store.commit("auth/logOut");
            throw new Error("This email is used by merchant");
          }
          if (this.$store.getters["auth/userStatus"] !== 1) {
            if (this.popup) {
              this.popup.focus();
              this.popup.close();
              this.popup = null;
            }
            this.$store.commit("auth/logOut");
            throw new Error("Please, confirm your email");
          }
          if (!Object.values(this.$store.getters["user/cart"]).length) {
            this.notifyParentWindow({
              type: "rocketfuel_get_cart",
            });
          }
          this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
            moduleInfo: {
              current: "Login Magic Link",
              activity: "continue with email button clicked",
            },
          });
          this.$router.push({ name: "Payment" });
          this.$refs.loader.hide();
        } catch (e) {
          this.error = e?.response?.data?.message
            ? e.response.data.message
            : e.message;
          this.$refs.loader.hide();
        }
      });
    },
    doSigin() {
      this.$store.commit("auth/setUserEmail", this.email);
      this.$emit("offMagic", false);
    },
    async signInContinue(values) {
      this.$refs.loader.start();
      try {
        const { email } = values;
        if (email) {
          const resp = await this.m.auth.loginWithEmailOTP({ email });
          if (resp) {
            const token = `Bearer ${resp}`;
            await this.magicSIGN(token);
          }
        } else {
          this.$refs.loader.hide();
        }
      } catch (err) {
        const messages = err.message.split("]");
        this.error = messages.length > 1 ? messages[1] : messages[0];
        this.$refs.loader.hide();
      }
    },
    async render() {
      this.$refs.loader.start();
      if (this.$refs.loader) {
        this.$refs.loader.hide();
      }
    },
  },
  mounted() {
    this.render();
    this.$refs.loader.hide();
  },
};
</script>

<style lang="scss" scoped>
.cs-input .input-wrapper__input {
  width: 100%;
  padding: 10px;
  color: #1b1f3b;
  font-weight: 300;
  font-size: 14px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  background-color: #fff;
  border: 1px solid #b2b7c5;
  letter-spacing: 0.04em;
  transition: 0.35s;
}
</style>
